import { NoResultsBlock } from 'view/pages/candidates/components';
import { Spinner } from 'view/components';
import { useFormContext } from 'react-hook-form-mui';
import { CANDIDATES_ITEMS_PER_PAGE } from 'view/pages/candidates/hooks/useGetCandidates';
import * as CS from 'view/pages/candidates/commonStyled';
import { JobPostsListItem } from 'view/pages/profile/components';
import * as S from './styled';

const JobPostsListBlock = ({ isLoading, data, onSubmit, page, setPage, queryAfterSubmit }) => {
  const { handleSubmit } = useFormContext<any>();

  return (
    <S.CandidatesListBlock>
      <S.CandidatesListBlockHeader>
        <S.CandidatesListBlockTitle>{data?.total || 0} job posts</S.CandidatesListBlockTitle>
      </S.CandidatesListBlockHeader>
      {isLoading && (
        <Spinner
          variant="outlined"
          style={{
            position: 'absolute',
            top: '0',
            left: '0',
            backgroundColor: 'rgba(217, 225, 255, 0.3)',
            width: '100%',
            height: '100%',
            zIndex: 10,
          }}
        />
      )}
      {!isLoading && !data?.total && (
        <NoResultsBlock
          title="Unfortunately, there are no results"
          subTitle={'Please try other variations of the search, \n or reset filters.'}
        />
      )}
      {data?.total && !!data?.data?.length ? (
        <>
          <S.CandidatesListBlockMainWrapper>
            <>
              {data?.data?.map((item) => {
                return (
                  <JobPostsListItem
                    candidate={item}
                    key={item.id}
                    queryAfterSubmit={queryAfterSubmit}
                  />
                );
              })}
            </>
          </S.CandidatesListBlockMainWrapper>
          <CS.CustomPagination
            count={Math.ceil(data.total / CANDIDATES_ITEMS_PER_PAGE)}
            shape="rounded"
            page={page}
            onChange={(e, page) => {
              setPage(page);
              setTimeout(() => {
                handleSubmit(onSubmit(page))();
              }, 0);
            }}
            style={{ margin: 'auto auto 0' }}
          />
        </>
      ) : null}
    </S.CandidatesListBlock>
  );
};

export default JobPostsListBlock;
